import { type TypedUseSelectorHook, useSelector } from "react-redux";
import type { OnlineOrderingState } from "reducers/online_ordering/onlineOrdering";

export const useOloSelector =
  useSelector as TypedUseSelectorHook<OnlineOrderingState>;
